export const COLUMNS_SIZE_MAP = {
  "1": 100,
  "2": 100,
  "3": 350,
  "4": 100,
  "5": 140,
  "6": 100,
  "7": 100,
  "8": 100,
  "9": 100,
  "10": 140,
  "11": 100,
  "12": 100,
  "13": 100,
  "14": 100,
  "15": 100,
  "16": 100,
  "17": 100,
  "18": 100,
  "19": 100,
  "20": 160,
  "21": 160,
  "22": 100,
  "23": 100,
  "24": 100,
}
